import { FileText, Presentation, Code2, Video, Link, FileEdit, ExternalLink } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { Resource } from '@/lib/api/lms';

const typeIcons: Record<string, LucideIcon> = {
  pdf: FileText, slides: Presentation, code_repo: Code2, recording: Video, link: Link, notes: FileEdit,
};
const typeLabels: Record<string, string> = {
  pdf: 'PDF', slides: 'Slides', code_repo: 'Code', recording: 'Recording', link: 'Link', notes: 'Notes',
};

interface ResourcesSectionProps {
  resources: Resource[];
}

export function ResourcesSection({ resources }: ResourcesSectionProps) {
  return (
    <section className="rounded-xl border border-border bg-card p-4">
      <h2 className="mb-3 font-heading text-base font-bold">Resources</h2>
      {!resources || resources.length === 0 ? (
        <p className="text-sm text-muted-foreground">No resources attached to this topic yet.</p>
      ) : (
        <div className="space-y-1">
          {resources.map((resource) => {
            const Icon = typeIcons[resource.type] ?? Link;
            const label = typeLabels[resource.type] ?? resource.type;
            return (
              <a key={resource.id} href={resource.url} target="_blank" rel="noopener noreferrer"
                className="group flex items-center gap-3 rounded-lg p-2.5 transition-colors hover:bg-muted/50">
                <Icon className="h-4 w-4 flex-shrink-0 text-muted-foreground" />
                <span className="flex-1 text-sm transition-colors group-hover:text-primary">{resource.title}</span>
                <span className="rounded bg-muted px-1.5 py-0.5 text-xs text-muted-foreground">{label}</span>
                <ExternalLink className="h-3.5 w-3.5 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
              </a>
            );
          })}
        </div>
      )}
    </section>
  );
}
